import { YhBox } from "@/erp_subpackage/components/YhBox";
import { importPropsConfig } from "@/erp_subpackage/utils/importFile";
import { Button, InputNumber, message, Modal, Upload } from "antd";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useQuestionModel } from "../questionModel";
import { questionService } from "../questionService";
import { DataTable } from "./DataTable";

export const DataBox = () => {
    const { t } = useTranslation();
    const { selectedRowKeys, setDetailDialogInfo, onRemove, exportQuestion, downloadTpl } = useQuestionModel();

    //导入成功
    const importCallback = async (list) => {
        if (list && list.length) {
        }
    }


    //作废
    const onSetting = async () => {
        let mode = "add";
        let day = "1"
        let { retData: retOne } = await questionService.settingOne("trigger_mechanism");
        if (retOne) { mode = "edit"; day = retOne.value }
        Modal.confirm({
            title: t(`paper.view.DataBox.触发设置`),
            content: <><span> {t(`paper.view.DataBox.设置`)} </span>
                <InputNumber
                    style={{ width: 60 }}
                    size="small"
                    defaultValue={day}
                    min="1"
                    max="1000"
                    onChange={(val) => { day = val }}
                    stringMode />
                <span>  {t(`paper.view.DataBox.天触发答题机制`)}</span></>,
            okText: t(`paper.view.DataBox.确定`),
            cancelText: t(`paper.view.DataBox.取消`),
            onOk: async () => {
                if (mode === "add") {
                    let { retData } = await questionService.settingInsert({
                        code: "trigger_mechanism",
                        value: day,
                        deleteFlag: 0
                    });
                    retData && message.success(t(`paper.view.DataBox.设置成功`))
                } else {
                    let { retData } = await questionService.settingUpdate({
                        id: retOne.id,
                        code: "trigger_mechanism",
                        value: day,
                        deleteFlag: 0
                    });
                    retData && message.success(t(`paper.view.DataBox.设置成功`))
                }
            },
        });
    }

    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setDetailDialogInfo("add")}
        > {t(`paper.view.DataBox.新增`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning(`${t(`paper.view.DataBox.请选择单条数据进行查看，点击鼠标右键可一键选中哦`)}！`)
                    return;
                }
                setDetailDialogInfo("look")
            }}
        > {t(`paper.view.DataBox.查看`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning(`${t(`paper.view.DataBox.请选择单条数据进行编辑，点击鼠标右键可一键选中哦`)}！`)
                    return;
                }
                setDetailDialogInfo("edit")
            }}
        > {t(`paper.view.DataBox.编辑`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning(`${t(`paper.view.DataBox.请选择单条数据进行删除，点击鼠标右键可一键选中哦`)}！`)
                    return;
                }
                onRemove()
            }}
        > {t(`paper.view.DataBox.删除`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => onSetting()}
        > {t(`paper.view.DataBox.触发设置`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => exportQuestion()}
        > {t(`paper.view.DataBox.导出`)}</Button>
        <Upload showUploadList={false}  {...importPropsConfig(`/exam/questionBank/import`, importCallback)}>
            <Button className="btn-item" shape="round"> {t(`paper.view.DataBox.导入`)}</Button>
        </Upload>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => downloadTpl()}
        > {t(`paper.view.DataBox.下载模板`)}</Button>
    </>;

    return (
        <YhBox title= {t(`paper.view.DataBox.问题列表`)} action={action}>
            <DataTable />
        </YhBox>
    )
}

